import React from 'react'
import Breadcrumbs from 'react-router-dynamic-breadcrumbs'
import './lgy-breadcrumbs.scss'
import { connect } from 'react-redux'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { formatNameCompact } from 'app/utils/userUtils'
import { formatLin } from 'app/utils/fieldUtils'

// TODO: surely we can auto-generate much of this, right? Or in the future, maybe there's a better breadcrumb library
const LgyBreadcrumbs = ({ users, announcements, fundingFee, setting }) => {
  const routes = {
    '/lgyhub': 'LGY Hub',
    '/lgyhub/help': 'LGY Help Center',
    '/lgyhub/help/faq': 'Frequently Asked Questions',
    '/lgyhub/help/ticket': 'Help Ticket Submission Form',
    '/lgyhub/announcements': 'Announcements',
    '/lgyhub/announcements/:announcementId': (url, { announcementId }) => announcementHeadlineFromId(announcementId),
    '/lgyhub/guaranty-calculator': 'Guaranty Percentage Calculator',
    '/lgyhub/chunked-upload': null,
    '/lgyhub/transition': 'Welcome!',
    '/lgyhub/oversight': 'Oversight Workspace',
    '/lgyhub/oversight/search': 'Search Audit Records',
    '/lgyhub/oversight/audits': 'Audits',
    '/lgyhub/oversight/create': 'Create New Audit',
    '/lgyhub/oversight/audits/:auditId/edit': 'Edit Audit',
    '/lgyhub/oversight/audits/:auditId': ':auditId',
    //appraiser breadcrumbs begin
    '/lgyhub/appraiser': 'Appraiser Workspace',
    '/lgyhub/appraiser/profile': 'Personal/Business Profile',
    '/lgyhub/appraiser/unavailability': 'Unavailability Dates',
    '/lgyhub/appraiser/geographic-areas': 'Geographic Areas',
    '/lgyhub/appraiser/locate-cases': 'Locate Cases',
    '/lgyhub/appraiser/locate-cases/canceled-90-days': 'Assignments Canceled in the Past 90 Days',
    '/lgyhub/appraiser/locate-cases/all-90-days': 'All Assignments in the Past 90 Days',
    '/lgyhub/appraiser/locate-cases/with-uploads': 'Assignments with Appraisals Uploaded in the Past 30 Days',
    '/lgyhub/appraiser/search': null,
    '/lgyhub/appraiser/:assignmentId': ':assignmentId',
    '/lgyhub/appraiser/:assignmentId/details': 'Details',
    '/lgyhub/appraiser/:assignmentId/notes': 'Notes',
    '/lgyhub/appraiser/:assignmentId/documents': 'Documents',
    '/lgyhub/appraiser/:assignmentId/correspondence': 'Correspondence',
    '/lgyhub/appraiser/:assignmentId/appraisalAssistance': 'Appraisal Assistance Processing Program',
    '/lgyhub/appraiser/search/:assignmentId': ':assignmentId',
    '/lgyhub/appraiser/search/:assignmentId/details': 'Details',
    '/lgyhub/appraiser/search/:assignmentId/notes': 'Notes',
    '/lgyhub/appraiser/search/:assignmentId/documents': 'Documents',
    '/lgyhub/appraiser/search/:assignmentId/correspondence': 'Correspondence',
    '/lgyhub/appraiser/search/:assignmentId/appraisalAssistance': 'Appraisal Assistance Processing Program',
    '/lgyhub/appraiser/locate-cases/:assignmentId': ':assignmentId',
    '/lgyhub/appraiser/locate-cases/:assignmentId/details': 'Details',
    '/lgyhub/appraiser/locate-cases/:assignmentId/notes': 'Notes',
    '/lgyhub/appraiser/locate-cases/:assignmentId/documents': 'Documents',
    '/lgyhub/appraiser/locate-cases/:assignmentId/correspondence': 'Correspondence',
    '/lgyhub/appraiser/locate-cases/:assignmentId/appraisalAssistance': 'Appraisal Assistance Processing Program',
    '/lgyhub/appraiser/locate-cases/canceled-90-days/:assignmentId': ':assignmentId',
    '/lgyhub/appraiser/locate-cases/canceled-90-days/:assignmentId/details': 'Details',
    '/lgyhub/appraiser/locate-cases/canceled-90-days/:assignmentId/notes': 'Notes',
    '/lgyhub/appraiser/locate-cases/canceled-90-days/:assignmentId/documents': 'Documents',
    '/lgyhub/appraiser/locate-cases/canceled-90-days/:assignmentId/correspondence': 'Correspondence',
    '/lgyhub/appraiser/locate-cases/canceled-90-days/:assignmentId/appraisalAssistance': 'Appraisal Assistance Processing Program',
    '/lgyhub/appraiser/locate-cases/all-90-days/:assignmentId': ':assignmentId',
    '/lgyhub/appraiser/locate-cases/all-90-days/:assignmentId/details': 'Details',
    '/lgyhub/appraiser/locate-cases/all-90-days/:assignmentId/notes': 'Notes',
    '/lgyhub/appraiser/locate-cases/all-90-days/:assignmentId/documents': 'Documents',
    '/lgyhub/appraiser/locate-cases/all-90-days/:assignmentId/correspondence': 'Correspondence',
    '/lgyhub/appraiser/locate-cases/all-90-days/:assignmentId/appraisalAssistance': 'Appraisal Assistance Processing Program',
    '/lgyhub/appraiser/locate-cases/with-uploads/:assignmentId': ':assignmentId',
    '/lgyhub/appraiser/locate-cases/with-uploads/:assignmentId/details': 'Details',
    '/lgyhub/appraiser/locate-cases/with-uploads/:assignmentId/notes': 'Notes',
    '/lgyhub/appraiser/locate-cases/with-uploads/:assignmentId/documents': 'Documents',
    '/lgyhub/appraiser/locate-cases/with-uploads/:assignmentId/correspondence': 'Correspondence',
    '/lgyhub/appraiser/locate-cases/with-uploads/:assignmentId/appraisalAssistance': 'Appraisal Assistance Processing Program',
    //appraiser breadcrumbs end
    '/lgyhub/profile': 'My Profile',
    '/lgyhub/profile/contact': 'Contact Information',
    '/lgyhub/profile/affiliation': 'Affiliate Information',
    '/lgyhub/admin': 'Admin Gear',
    '/lgyhub/admin/users': 'Users',
    '/lgyhub/admin/batch-jobs': 'Batch Jobs',
    '/lgyhub/admin/enterprise-settings': 'Enterprise Settings',
    /* If we can find the user in the store, then display their name, otherwise just display the user ID. 
    For example if there was a fresh page load, the user might not exist even though we have the user ID immediately. */
    '/lgyhub/admin/users/:userId': (url, { userId }) => userNameFromUserId(userId),
    '/lgyhub/admin/users/:userId/contact': 'Contact Information',
    '/lgyhub/admin/users/:userId/events': 'Events',
    '/lgyhub/admin/users/:userId/permissions': 'Permissions',
    '/lgyhub/admin/users/:userId/affiliations': 'Affiliations',
    '/lgyhub/admin/users/:userId/external': 'External Account Connections',
    '/lgyhub/admin/users/:userId/status': 'Status',
    '/lgyhub/admin/jobs': 'Jobs',
    '/lgyhub/admin/announcements': 'Announcements',
    '/lgyhub/home-builders': 'Builder Report',
    '/lgyhub/condo-report': 'Condo Report',
    '/lgyhub/vis-browser': 'VIS Browser',
    '/lgyhub/NADL/records': 'Record Maintenance',
    '/lgyhub/NADL/reports': 'Run Reports',
    '/lgyhub/funding-fee': 'Funding Fee',
    '/lgyhub/funding-fee/refunds': 'Refunds',
    '/lgyhub/funding-fee/refunds/processing': 'Refund Processing',
    '/lgyhub/funding-fee/refunds/search': 'Search by LIN',
    '/lgyhub/funding-fee/refunds/:id': (_url, { id }) => formatLin(fundingFee[id]?.lin) ?? id,
    '/lgyhub/funding-fee/refunds/report': 'Retrieve Report',
    '/lgyhub/funding-fee/refunds/:refundId/note': 'Notes',
    '/lgyhub/funding-fee/refunds/:refundId/note/:noteId': (_url, { noteId }) => `Note #${noteId}`,
    '/lgyhub/funding-fee/refunds/:refundId/note/new': 'New Note',
    '/lgyhub/admin/settings': 'Settings',
    '/lgyhub/admin/settings/:pageId': setting?.title,
    '/lgyhub/admin/settings/:pageId/:sectionId': (_url, { sectionId }) => setting?.sections?.find(({ id }) => id === sectionId)?.title
  }

  const userNameFromUserId = (userId) => users[userId] && users[userId].firstName ? formatNameCompact(users[userId]) : userId
  const announcementHeadlineFromId = (announcementId) => {
    // TODO: Fix this, this is a string to int comparison
    // eslint-disable-next-line
    const announcement = announcements.find(a => a.id == announcementId)
    if (announcement) {
      console.log('Found announcement', announcement)
      return announcement.headline
    }
    console.log('Didn\'t find announcement for ID', announcementId)
    return announcementId
  }

  return (
    <Breadcrumbs
      mappedRoutes={routes}
      WrapperComponent={(props) => <span className='lgy-breadcrumb' >{props.children}</span>}
      LinkComponent={(props) => <span className='lgy-breadcrumb-link'><LgyLink {...(props.children.props)} /></span>}
      ActiveLinkComponent={(props) => <span className='lgy-breadcrumb-active'>{props.children}</span>}
    />
  )
}

const mapStateToProps = state => ({
  users: state.adminState.userAdmin.users,
  announcements: state.announcementsState.announcements,
  fundingFee: state.fundingFee,
  setting: state.adminState.settings.currentPage 
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(LgyBreadcrumbs)
